import React from 'react';

/**
 * Returns the provider succesful page.
 * @returns the provider succesful page.
 */
const ProviderSuccesfulPage = (): React.ReactElement => {
    /*** HOOKS ***/

    /*** EFFECTS ***/

    /*** METHODS ***/

    /*** COMPONENTS ***/

    return <></>;
};

export default ProviderSuccesfulPage;
